import React, { FC } from 'react';
import type { StepPageProps } from '../../../assessment-portal';
import type { CarePathwayState } from '../../types/flow';
import CarePathwayPage from '../care-pathway-page';

const CarePathwayStep: FC<StepPageProps> = ({
  defaultValues,
  onBack,
  onNext,
}) => (
  <CarePathwayPage
    defaultValues={defaultValues as CarePathwayState | undefined}
    onBack={onBack}
    onNext={(values) => onNext(values)}
  />
);

export default CarePathwayStep;
